<template>
    <v-container fluid fill-height>
        <v-row class="ma-0 pa-0">

            <v-btn icon @click="indietro()" class="mt-2" v-if="role === 'admin' || role === 'auditor'">
                <v-icon>arrow_back</v-icon>
            </v-btn>

            <v-btn icon @click="caricaDati()" class="mt-2">
                <v-icon>refresh</v-icon>
            </v-btn>

            <v-text-field v-model="search" append-icon="search" placeholder="Cerca..." class="mt-2 mb-2 ml-2" solo
                clearable hide-details dense />

            <v-menu offset-y v-if="role === 'admin'" transition="slide-y-transition">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn color="primary" v-bind="attrs" v-on="on" class="ml-4 mt-2">
                        Gestione tabelle
                        <v-icon right large>arrow_drop_down</v-icon>
                    </v-btn>
                </template>

                <v-list>
                    <v-list-item @click="showDichiarazioni = true">
                        <v-list-item-title>Dichiarazioni FSC</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="showCategorie = true">
                        <v-list-item-title>Gruppi di prodotto</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>

            <v-btn v-tooltip.bottom="'Esporta dati'" @click="esportaDati()" class="mt-2 ml-2 elevation-2"
                color="primary" :disabled="!variante">
                <v-icon class="mr-2">cloud_download</v-icon>Esporta dati</v-btn>
        </v-row>

        <v-row class="ma-0 pa-0 ml-2" v-if="role === 'admin' || role === 'auditor'">
            Cliente: <strong class="ml-2">{{ cliente }}</strong>
            <span v-if="variante" class="ml-4 text--secondary">Variante: {{ descrizioneVariante }}</span>
        </v-row>

        <v-row class="ma-0 pa-0" v-if="variante">
            <v-tabs v-model="tab" class="mt-2" grow centered>
                <v-tab>Input</v-tab>
                <v-tab>Output</v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab" grow style="width: 100%;">
                <v-tab-item :key="1">
                    <v-row class="ma-0 pa-0">
                        <v-btn color="success" @click="apriDialogMatPrima()" class="mt-2 ml-2">
                            <v-icon left>add</v-icon> Aggiungi materiale in ingresso
                        </v-btn>
                        <v-spacer />

                        <v-btn @click="apriDialogDeclassamento()" class="mt-2 ml-2">
                            <v-icon left>trending_down</v-icon> Declassamento materiale
                        </v-btn>
                    </v-row>

                    <v-row class="ma-0 pa-0 mt-4">
                        <v-data-table :headers="headersMatPrime" :items="datiMatPrime" :search="search"
                            class="elevation-1" hide-default-footer :items-per-page="-1" fixed-header height="70vh"
                            dense style="width: 100%;" no-data-text="Nessun dato disponibile"
                            no-results-text="Nessun risultato trovato">
                            <template v-slot:item.gruppoCategoriaFSC="{ item }">
                                {{ item.gruppoCategoriaFSC
                                ? item.gruppoCategoriaFSC.codGruppo + ' ' + (item.gruppoCategoriaFSC.traduzione || '')
                                : '' }}
                            </template>
                            <template v-slot:item.dichiarazioneFSC="{ item }">
                                {{ item.dichiarazioneFSC ? item.dichiarazioneFSC.descrizione : '' }}
                            </template>
                            <template v-slot:item.qtaRimanente="{ item }">
                                <span :class="{ 'text--disabled': item.qtaRimanente <= 0 }">{{ item.qtaRimanente }}</span>
                            </template>
                            <template v-slot:item.actions="{ item }">
                                <v-btn icon color="primary" @click="apriDialogMatPrima(item)"
                                    v-tooltip.top="'Modifica rigo'">
                                    <v-icon>edit</v-icon>
                                </v-btn>
                                <v-btn icon color="primary" @click="duplicaRigo(item)" v-tooltip.top="'Duplica rigo'">
                                    <v-icon>content_copy</v-icon>
                                </v-btn>
                            </template>
                        </v-data-table>
                    </v-row>
                </v-tab-item>

                <v-tab-item :key="2">
                    <v-btn color="success" @click="apriDialogCommesse()" class="mt-2 ml-2">
                        <v-icon left>add</v-icon> Registra vendita
                    </v-btn>
                    <v-row class="ma-0 pa-0 mt-4">
                        <v-data-table :headers="headersCommesse" :items="datiCommesse" :search="search"
                            class="elevation-1" hide-default-footer :items-per-page="-1" fixed-header height="70vh"
                            dense style="width: 100%;" no-data-text="Nessun dato disponibile"
                            no-results-text="Nessun risultato trovato">
                            <template v-slot:item.actions="{ item }">
                                <v-btn icon color="primary" @click="apriDialogCommesse(item)">
                                    <v-icon>edit</v-icon>
                                </v-btn>
                            </template>
                        </v-data-table>
                    </v-row>
                </v-tab-item>
            </v-tabs-items>
        </v-row>

        <v-row class="ma-0 pa-0 mt-6" v-else-if="configCaricata">
            <v-alert type="warning" outlined>
                Il registro sintesi personalizzato non è abilitato per questa azienda.
            </v-alert>
        </v-row>

        <MateriePrimePers :dialog="showMatPrima" @close="chiudiMatPrima" :editItem="materiaSel" :compCode="companyCode"
            :variante="variante" />

        <CommessePers :dialog="showCommessa" @close="chiudiCommessa" :editItem="elementoSel" :compCode="companyCode"
            :variante="variante" />

        <!-- Anagrafiche condivise con il registro FSC -->
        <CategorieFSC :dialogFSC="showCategorie" @close="showCategorie = false" :compCode="companyCode" />

        <DichiarazioniFSC :dialogFSC="showDichiarazioni" @close="showDichiarazioni = false" :compCode="companyCode" />

        <DeclassamentoMaterialePers :dialog="dialogDeclassamento" @close="chiudiDialogDeclassamento"
            :compCode="companyCode" :variante="variante" />

        <EsportaDatiPers :dialog="dialogDownload" @close="chiudiEsporta" :compCode="companyCode"
            :variante="variante" />
    </v-container>
</template>

<script>
import DichiarazioniFSC from '@/components/registroSintesi/DichiarazioniFSC.vue'
import CategorieFSC from '@/components/registroSintesi/CategorieFSC.vue'
import MateriePrimePers from '@/components/registroSintesiPers/MateriePrimePers.vue'
import CommessePers from '@/components/registroSintesiPers/CommessePers.vue'
import DeclassamentoMaterialePers from '@/components/registroSintesiPers/DeclassamentoMaterialePers.vue'
import EsportaDatiPers from '@/components/registroSintesiPers/EsportaDatiPers.vue'

import { get_config, get_log_commesse, get_materiali, get_verifica_accesso } from '@/api/api.registroSintesiPers.js'

export default {
    components: {
        DichiarazioniFSC,
        CategorieFSC,
        MateriePrimePers,
        CommessePers,
        DeclassamentoMaterialePers,
        EsportaDatiPers,
    },

    data() {
        return {
            tab: 0,
            variante: "",               // "CARTONE" | "LEGNO", vuota se il registro non e' abilitato
            configCaricata: false,

            showDichiarazioni: false,   //dialog anagrafica dichiarazioni FSC
            showCategorie: false,       //dialog anagrafica gruppi di prodotto
            showCommessa: false,        //dialog inserimento e modifica commesse
            showMatPrima: false,        //dialog inserimento e modifica materie prime

            search: '',
            datiCommesse: [],
            elementoSel: {},

            materiaSel: {},
            datiMatPrime: [],

            companyCode: "",
            cliente: "",

            dialogDeclassamento: false,
            dialogDownload: false,
        }
    },

    methods: {
        indietro() {
            if (this.role !== "utente")
                this.$router.push({ path: "/registro-pers" });
            else
                this.$router.push({ path: "/" });
        },

        parametriAzienda() {
            return this.role !== "utente" ? "?companyCode=" + this.companyCode : "";
        },

        async caricaDati() {
            if (!this.variante) return;
            if (this.tab === 0) {
                await this.caricaDatiMatPrime();
            } else if (this.tab === 1) {
                await this.caricaDatiCommesse();
            }
        },

        async caricaConfig() {
            let res = await get_config(this.parametriAzienda());
            this.variante = res.data.variante || "";
            this.configCaricata = true;
        },

        //#region Commesse

        apriDialogCommesse(item = null) {
            if (!item) {
                this.elementoSel = {
                    companyCode: this.companyCode,
                    id: -1,
                    riferimento: '',
                    clienteUscita: '',
                    note: '',
                    ddt: [],
                    fatture: [],
                    terzistiInv: [],
                    terzistiRic: [],
                    sezioni: [],
                };
            } else {
                this.elementoSel = JSON.parse(JSON.stringify(item));
            }
            this.showCommessa = true;
        },

        async caricaDatiCommesse() {
            let res = await get_log_commesse(this.parametriAzienda());
            this.datiCommesse = res.data;
        },

        chiudiCommessa(aggiorna = false) {
            this.showCommessa = false;
            if (aggiorna) {
                this.caricaDatiCommesse();
                this.caricaDatiMatPrime();   // la giacenza dei materiali cambia con i consumi
            }
            this.elementoSel = {};
        },

        //#endregion

        //#region Materie Prime

        async caricaDatiMatPrime() {
            let res = await get_materiali(this.parametriAzienda());
            this.datiMatPrime = res.data;
        },

        duplicaRigo(item) {
            let itemDup = JSON.parse(JSON.stringify(item));
            itemDup.idMateriale = -1;
            this.apriDialogMatPrima(itemDup);
        },

        apriDialogMatPrima(item = null) {
            if (!item) {
                this.materiaSel = {
                    companyCode: this.companyCode,
                    idMateriale: -1,
                    fornitore: '',
                    nBolla: '',
                    dataBolla: '',
                    nFattura: '',
                    dataFattura: '',
                    gruppoCategoriaFSC: null,
                    dichiarazioneFSC: null,
                    essenza: '',
                    um: '',
                    qta: null,
                    qtaDDT: null,
                    codiceAcquisto: '',
                    dettaglioProdotto: '',
                    descrizione: '',
                };
            } else {
                this.materiaSel = JSON.parse(JSON.stringify(item));
            }
            this.showMatPrima = true;
        },

        chiudiMatPrima(aggiorna = false) {
            this.showMatPrima = false;
            if (aggiorna) {
                this.caricaDatiMatPrime();
            }
            this.materiaSel = {};
        },

        //#endregion

        //#region Declassamento materiale

        apriDialogDeclassamento() {
            this.dialogDeclassamento = true;
        },

        chiudiDialogDeclassamento() {
            this.dialogDeclassamento = false;
            this.caricaDatiMatPrime();
        },

        //#endregion

        esportaDati() {
            this.dialogDownload = true;
        },

        chiudiEsporta() {
            this.dialogDownload = false;
        },

        async verificaAziendaUrl() {
            // Al primo caricamento diretto della pagina (es. url incollato in barra indirizzi)
            // il ruolo utente puo' non essere ancora stato caricato in store (richiesta
            // asincrona avviata da Main.vue): senza attenderlo i controlli sotto verrebbero
            // saltati (this.role vuoto) lasciando la pagina accessibile senza verifica.
            if (!this.role) {
                await this.$store.dispatch("user/userInfo");
            }

            this.companyCode = this.$route.params.codice || null;

            // Un utente cliente non deve mai poter vedere/operare su un'altra azienda modificando
            // il codice nell'URL: se non corrisponde alla propria azienda, si forza quest'ultima
            // e si corregge l'indirizzo, invece di fidarsi di quanto scritto nell'URL.
            if (this.role === "utente" && this.companyCode !== this.miaAzienda) {
                this.companyCode = this.miaAzienda;
                this.$router.replace({ path: "/registro-pers/" + this.miaAzienda }).catch(() => { });
                return;
            }

            // Un auditor puo' vedere solo le aziende a cui e' stato assegnato: se prova ad accedere
            // ad un'altra azienda modificando il codice nell'URL, viene rimandato all'elenco.
            if (this.role === "auditor" && this.companyCode) {
                let res = await get_verifica_accesso(this.companyCode);
                if (!res.data) {
                    this.$router.replace({ path: "/registro-pers" }).catch(() => { });
                    return;
                }
            }

            if (!this.companyCode) {
                this.$router.push({ path: "/" });
                return;
            }

            this.cliente = this.$route.query.cliente || "";
            await this.caricaConfig();
            if (!this.variante) return;

            // Link "apri commessa" dalla pagina Storico Output: apre direttamente la commessa in modifica
            const apriCommessa = this.$route.query.apriCommessa;
            if (apriCommessa) {
                this.tab = 1;
                await this.caricaDatiCommesse();
                const item = this.datiCommesse.find((c) => String(c.id) === String(apriCommessa));
                if (item) this.apriDialogCommesse(item);
                else this.$toast.alert("Commessa non trovata");
            } else {
                this.caricaDati();
            }
        },
    },

    mounted() {
        this.verificaAziendaUrl();
    },

    computed: {
        role() {
            return this.$store.getters['user/getRole'];
        },

        miaAzienda() {
            return this.$store.getters['user/getCompanyCode'];
        },

        descrizioneVariante() {
            return this.variante === "CARTONE" ? "Cartone (fogli / scatole)" : (this.variante === "LEGNO" ? "Legno (mc / ml)" : "");
        },

        headersMatPrime() {
            const azioni = { text: 'Azioni', value: 'actions', sortable: false };
            if (this.variante === "CARTONE") {
                return [
                    { text: 'Codice', value: 'idMateriale' },
                    { text: 'Fornitore', value: 'fornitore' },
                    { text: 'DDT', value: 'nBollaText' },
                    { text: 'Fattura', value: 'nFatturaText' },
                    { text: 'Gruppo di prodotto', value: 'gruppoCategoriaFSC', sortable: false },
                    { text: 'Dichiarazione FSC', value: 'dichiarazioneFSC', sortable: false },
                    { text: 'Codice di acquisto', value: 'codiceAcquisto' },
                    { text: 'Dettaglio prodotto', value: 'dettaglioProdotto' },
                    { text: 'UM', value: 'um' },
                    { text: 'Q.tà da DDT', value: 'qtaDDT' },
                    { text: 'Q.tà considerata', value: 'qta' },
                    { text: 'Residuo', value: 'qtaRimanente' },
                    { text: 'Descrizione', value: 'descrizione' },
                    azioni,
                ];
            }
            return [
                { text: 'Codice', value: 'idMateriale' },
                { text: 'Fornitore', value: 'fornitore' },
                { text: 'DDT', value: 'nBollaText' },
                { text: 'Fattura', value: 'nFatturaText' },
                { text: 'Gruppo di prodotto', value: 'gruppoCategoriaFSC', sortable: false },
                { text: 'Essenza', value: 'essenza' },
                { text: 'Dichiarazione FSC', value: 'dichiarazioneFSC', sortable: false },
                { text: 'UM', value: 'um' },
                { text: 'Q.tà', value: 'qta' },
                { text: 'Residuo', value: 'qtaRimanente' },
                { text: 'Descrizione', value: 'descrizione' },
                azioni,
            ];
        },

        headersCommesse() {
            const intestazioni = [
                { text: 'ID', value: 'id' },
                { text: 'Riferimento', value: 'riferimento' },
                { text: 'Cliente', value: 'clienteUscita' },
                { text: 'Gruppi di prodotto', value: 'gruppiProdotto' },
            ];
            if (this.variante !== "CARTONE")
                intestazioni.push({ text: 'Essenze', value: 'essenze' });
            intestazioni.push(
                { text: 'Dichiarazioni FSC', value: 'dichiarazioniFSC' },
                { text: 'Terzisti', value: 'terzisti' },
                { text: 'Azioni', value: 'actions', sortable: false },
            );
            return intestazioni;
        },
    },

    watch: {
        tab() {
            this.caricaDati();
        },

        // copre anche il caso (raro con lo history mode del router) in cui il parametro :codice
        // cambi senza un ricaricamento completo della pagina, che ometterebbe mounted()
        '$route.params.codice'() {
            this.verificaAziendaUrl();
        },
    }
}
</script>
